import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Button from "../../../common/Button";
import Close from "../../../images/newDesign/close.nocolor.svg";
import { SvgIcon } from "../../../ui/SvgIcon";
import { StyledUploadExcelPopUp } from "./UploadExcelPopUp.styled";

const UploadExcelPopUp = ({ show, onModalHide }) => {
    const {t} = useTranslation();

    return (
        <StyledUploadExcelPopUp show={show} onHide={onModalHide} centered>
            <Modal.Header>
                <button onClick={onModalHide}>
                    <SvgIcon href={Close} size={16} />
                </button>
            </Modal.Header>
            <Modal.Body>
                <center>
                    <div className="title">{t('reports.ran_into_problem')}</div>
                    <div className="info">{t('reports.uploaded_file_not_identified')}</div>
                    <div className="info bottom-block">{t('reports.mark_transactions_manually')}</div>
                    <Button onClick={onModalHide}>{t('reports.understood')}</Button>
                </center>
            </Modal.Body>
        </StyledUploadExcelPopUp>
    );
}

export default UploadExcelPopUp;